import { useState } from "react";

export const useSelectTableRow = (userData: any) => {
  const [selected, setSelected] = useState<readonly number[]>([]);

  const isSelected = (id: number) => selected.indexOf(id) !== -1;

  const handleToggle = (event: React.MouseEvent<unknown>, id: number) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: readonly number[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = userData.map((n: any) => n.id);
      setSelected(newSelected);
      return;
    }

    setSelected([]);
  };

  return { selected, isSelected, handleToggle, handleSelectAllClick };
};
